import React from 'react'
import { useLocation } from 'react-router-dom'
import { firebase } from 'firebaseApp'

/* FIREBASE API */
export const getFirebaseStorageURL = async (gsUrl: string, fileName: string) => {
  if (!gsUrl.includes('gs://')) return gsUrl
  await firebase
    .storage()
    .refFromURL(gsUrl)
    .updateMetadata({ contentDisposition: `attachment;filename=${fileName}` })

  const firebaseCSVUrl = await firebase.storage().refFromURL(gsUrl).getDownloadURL()

  return firebaseCSVUrl
}

export const listAllFiles = async (url: string) => {
  const ref = firebase.storage().refFromURL(url)
  const files = await ref.listAll()
  return files
}

/* API KEYBOARD EVENT */

export const useDisableCtrlFetch = () => {
  const [ctrlFetchEnabled, setCtrlFetchEnabled] = React.useState(true)

  const handleFocus = (e: Event) => {
    setCtrlFetchEnabled(true)
  }

  const handleClick = (e: MouseEvent) => {
    if (e.button === 0) setCtrlFetchEnabled(!e.ctrlKey)
  }

  const handleKeyUp = (e: KeyboardEvent) => {
    if (e.key === 'Control') setCtrlFetchEnabled(true)
  }

  React.useEffect(() => {
    window.addEventListener('blur', handleFocus)
    document.addEventListener('visibilitychange', handleFocus)
    document.addEventListener('mousedown', handleClick)
    document.addEventListener('keyup', handleKeyUp)
    return () => {
      window.removeEventListener('blur', handleFocus)
      document.addEventListener('visibilitychange', handleFocus)
      document.removeEventListener('mousedown', handleClick)
      document.removeEventListener('keyup', handleKeyUp)
    }
    // eslint-disable-next-line
  }, [])

  return { ctrlFetchEnabled }
}

/* QUERY PARAMS */

export const useGetUrlQueryParams = (param: string): string[] => {
  const searchParams = new URLSearchParams(useLocation().search)
  return searchParams.getAll(param)
}

export const getQueryParamsForAll = (queryString: string, queryKey: string, value: string[], excludeAll?: boolean) => {
  let queryParams = queryString

  if (!value.includes('all') || excludeAll) {
    const newValue = excludeAll ? value.filter((item) => item !== 'all') : value
    const queryParamValue = newValue.map((item) => encodeURIComponent(item)).join('Ç')
    queryParams = `${queryParams}&${queryKey}=${queryParamValue}`
  }

  return queryParams
}

export const getParamsForAll = (value: string[], type: 'only' | 'exclude') => {
  if (value.includes('all')) {
    switch (type) {
      case 'only': {
        return ['all']
      }
      case 'exclude': {
        return value.filter((item) => item !== 'all')
      }
    }
  }

  return value
}
